"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var TermOfUseComponent = /** @class */ (function () {
    function TermOfUseComponent() {
    }
    TermOfUseComponent.prototype.ngOnInit = function () {
    };
    return TermOfUseComponent;
}());
exports.TermOfUseComponent = TermOfUseComponent;
